import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ExportAnnualPDF = ({
  student,
  standardLabel,
  divisionLabel,
  marksData,
  maxMarksData,
  annualPercent,
  finYearLabel,
  criteriaResult,
}) => {
  const doc = new jsPDF("p", "mm", "a4");

  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("SHRADHANAND BAL MANDIR SENIOR SECONDARY SCHOOL", 105, 15, {
    align: "center",
  });

  doc.setFontSize(12);
  doc.text("Kamre, Ratu Road, Ranchi (Jharkhand) - 835222", 105, 20, {
    align: "center",
  });
  doc.text(
    "Affliated to CBSE, New Delhi(Affliation Number - 3430132, School No. - 66328)",
    105,
    25,
    {
      align: "center",
    },
  );

  doc.line(10, 28, 200, 28);

  doc.setFontSize(18);
  doc.text("PROGRESS REPORT", 105, 35, { align: "center" });

  doc.setFontSize(15);
  doc.text(`Annual Examination ${finYearLabel}`, 105, 40, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.text(`Student Name : ${student?.name || ""}`, 14, 55);
  doc.text(`Class / Section : ${standardLabel} ${divisionLabel}`, 14, 65);
  doc.text(`Admission Number : ${student?.admission || ""}`, 14, 75);
  doc.text(`Roll No : ${student?.roll || ""}`, 140, 75);

  const marksHead = [
    [
      "Subject",
      "Periodic Test",
      "Internal Assessment",
      "Half Yearly",
      "Annual Exam",
      "Total",
      "Grade",
    ],
    [
      "",
      annualPercent.pt,
      annualPercent.ia,
      annualPercent.hy,
      annualPercent.ae,
      100,
      "A1-E1",
    ],
  ];

  const marksBody = marksData.map((row) => [
    row.subjectName,
    row.pt,
    row.ia,
    row.hy,
    row.ae,
    row.total,
    row.grade,
  ]);

  const totalAnnual = marksData.reduce(
    (sum, row) => sum + (Number(row.total) || 0),
    0,
  );

  marksBody.push(["", "", "", "", "TOTAL", totalAnnual, "RANK"]);

  const percentage = marksData.length > 0 ? totalAnnual / marksData.length : 0;

  marksBody.push([
    "",
    "",
    "",
    "",
    "PERCENTAGE",
    `${percentage.toFixed(2)}%`,
    "",
  ]);

  autoTable(doc, {
    head: marksHead,
    body: marksBody,
    startY: 80,
    theme: "grid",
    margin: { left: 10, right: 10 },
    styles: { fontSize: 9, halign: "center", lineWidth: 0.1, lineColor: 0 },
    columnStyles: { 0: { halign: "left" } },
  });

  doc.setFontSize(10);

  const afterMarksY = doc.lastAutoTable.finalY + 20;

  const gradeHead = [
    [
      { content: "Grade Subject" },
      {
        content: "Grade",
      },
    ],
  ];

  const gradeBody = criteriaResult.map((row) => [row.criteria, row.grade]);

  autoTable(doc, {
    head: gradeHead,
    body: gradeBody,
    startY: afterMarksY,
    theme: "grid",
    styles: { fontSize: 9, halign: "left" },
    columnStyles: {
      0: { cellWidth: 30 }, // Grade Subject
      1: { cellWidth: 15 }, // Grade
    },
  });

  const gradeTableTopY = afterMarksY;
  const gradeTableBottomY = doc.lastAutoTable.finalY;
  const gradeTableHeight = gradeTableBottomY - gradeTableTopY;

  const pageWidth = 210;
  const leftMargin = 14;
  const gradeTableWidth = 45;
  const gap = 6;

  const remarksX = leftMargin + gradeTableWidth + gap;
  const remarksWidth = pageWidth - remarksX - leftMargin;

  doc.rect(remarksX, gradeTableTopY, remarksWidth, gradeTableHeight);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);

  doc.text("Class Teacher's Remarks:", remarksX + 1, gradeTableTopY + 5);

  const finalY = gradeTableBottomY + 20;

  doc.text("Parents Sign", 14, finalY);
  doc.text("Class Teacher Sign", 50, finalY);
  doc.text("Principal Sign", 150, finalY);

  doc.save(`${student?.name || "Student"}_Annual_Report.pdf`);
};

export default ExportAnnualPDF;
